// dependencies
import Router from "yarrr";
import React, { Suspense } from "react";

// components
import Loading from "Components/Spinner/PageSpinner";

// routes
import routes from "App/routesList";

// components
import EnvironmentContext from "App/EnvironmentContext";

const Content = () => (
	<div>
		<Suspense fallback={<Loading />}>
			<EnvironmentContext.Consumer>
				{(environment) => <Router routes={routes} environment={environment} />}
			</EnvironmentContext.Consumer>
		</Suspense>
	</div>
);

export default Content;
